import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { OrderLogFilters, OrderLogSlice } from "./orderLogsTypes.ts";

const initialState: OrderLogSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "createdTime",
    order: "desc",
  },
};

export const orderLogsSlice = createSlice({
  name: "orderLogs",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<OrderLogSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<OrderLogSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof OrderLogFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<OrderLogSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  orderLogsSlice.actions;

export const selectPage = (state: RootState) => state.orderLogs.page;
export const selectRowsPerPage = (state: RootState) =>
  state.orderLogs.rowsPerPage;
export const selectFilter = (state: RootState) => state.orderLogs.filter;
export const selectSort = (state: RootState) => state.orderLogs.sort;

export default orderLogsSlice.reducer;
